module.exports = __webpack_public_path__ + "img/cave-vin-blanc-en-ligne-boutrais-medium.ec4cf4be.png";